import { ISegmentedButtonOption } from '../segmented-button/segmented-button.interface';
import { EAiAssistantType, EAiAssistSource, EAiContextLevel, IAiAssistSourceConfig } from './ai-assist-shell.interface';

const ASSIST_I18N = 'page.artificialIntelligence.assistDialog';
const WHITEBOARD_I18N = 'page.whiteboard.ai';
const ISHIKAWA_I18N = 'page.ishikawa.ai';
const REPORT_I18N = 'page.artificialIntelligence.reportDialog';

/** Same limit as the API DTOs of every AI assist request. */
export const AI_ASSIST_PROMPT_MAX_LENGTH = 1000;

/** The API's `assistantType` behind each source: its quick actions are the active rows of that type. */
export const AI_ASSIST_ASSISTANT_TYPES: Readonly<Record<EAiAssistSource, EAiAssistantType>> = {
  [EAiAssistSource.itemModal]: EAiAssistantType.itemAssist,
  [EAiAssistSource.itemReport]: EAiAssistantType.itemReport,
  [EAiAssistSource.whiteboard]: EAiAssistantType.whiteboard,
  [EAiAssistSource.ishikawa]: EAiAssistantType.ishikawa,
};

/** Only the texts; the quick actions come from `GET ai-quick-actions`. */
export const AI_ASSIST_SOURCES: Readonly<Record<EAiAssistSource, IAiAssistSourceConfig>> = {
  [EAiAssistSource.itemModal]: {
    loadingKey: `${ASSIST_I18N}.loadingTitle`,
    previewSubtitleKey: `${ASSIST_I18N}.previewSubtitle`,
    promptPlaceholderKey: `${ASSIST_I18N}.promptPlaceholder`,
    subtitleKey: `${ASSIST_I18N}.subtitle`,
  },
  [EAiAssistSource.itemReport]: {
    loadingKey: `${REPORT_I18N}.loading`,
    previewSubtitleKey: `${REPORT_I18N}.previewSubtitle`,
    promptPlaceholderKey: `${REPORT_I18N}.promptPlaceholder`,
    subtitleKey: `${REPORT_I18N}.subtitle`,
  },
  [EAiAssistSource.whiteboard]: {
    loadingKey: `${WHITEBOARD_I18N}.loading`,
    previewSubtitleKey: `${WHITEBOARD_I18N}.previewSubtitle`,
    promptPlaceholderKey: `${WHITEBOARD_I18N}.promptPlaceholder`,
    subtitleKey: `${WHITEBOARD_I18N}.subtitle`,
  },
  [EAiAssistSource.ishikawa]: {
    loadingKey: `${ISHIKAWA_I18N}.loading`,
    previewSubtitleKey: `${ISHIKAWA_I18N}.previewSubtitle`,
    promptPlaceholderKey: `${ISHIKAWA_I18N}.promptPlaceholder`,
    subtitleKey: `${ISHIKAWA_I18N}.subtitle`,
  },
};

const CONTEXT_LEVEL_I18N = `${ASSIST_I18N}.contextLevel`;

/** Every AI dialog offers the same choice; the viewer's last one is remembered. */
export const AI_CONTEXT_LEVEL_STORAGE_KEY = 'aiContextLevel';
export const AI_CONTEXT_LEVEL_DEFAULT: EAiContextLevel = EAiContextLevel.standard;
export const AI_CONTEXT_LEVEL_CAPTION_KEY = `${CONTEXT_LEVEL_I18N}.caption`;
export const AI_CONTEXT_LEVEL_OPTIONS: ISegmentedButtonOption<EAiContextLevel>[] = [
  {
    icon: 'short_text',
    labelKey: `${CONTEXT_LEVEL_I18N}.basic`,
    tooltipKey: `${CONTEXT_LEVEL_I18N}.basicHint`,
    value: EAiContextLevel.basic,
  },
  {
    icon: 'article',
    labelKey: `${CONTEXT_LEVEL_I18N}.standard`,
    tooltipKey: `${CONTEXT_LEVEL_I18N}.standardHint`,
    value: EAiContextLevel.standard,
  },
  {
    icon: 'library_books',
    labelKey: `${CONTEXT_LEVEL_I18N}.full`,
    tooltipKey: `${CONTEXT_LEVEL_I18N}.fullHint`,
    value: EAiContextLevel.full,
  },
];
